import { createApp } from 'vue';
import RtfToPdfConverter from '../Components/RtfToPdfConverter.vue';

const root = document.getElementById('rtf-to-pdf-converter');
if (root) {
  createApp(RtfToPdfConverter).mount('#rtf-to-pdf-converter');
}
